import React from "react";
import FullCalendar, { formatDate } from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import AppointmentDetailsCalander from "./AppointmentDetailsCalander";

export default class DemoApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weekendsVisible: true,
      currentEvents: [],
      appointmentList: props.appointmentList,
    };
  }

  componentDidMount() {
    let initialValue = [];
    this.props.appointmentList.map((appointment) => {
      if (appointment.status && appointment.status.indexOf("CANCEL") < 0) {
        initialValue.push({
          id: appointment.id,
          title: appointment.consultationType + "-" + appointment.description,
          start: moment(appointment.startDateTime).format("YYYY-MM-DD hh:mm a"),
          end: moment(appointment.endDateTime).format("YYYY-MM-DD hh:mm a"),
        });
      }
    });
    this.setState({ currentEvents: initialValue });
  }
  handleClose() {
    this.setState({
      showDialogue: !this.state.showDialogue,
    });
  }
  handleWeekendsToggle = () => {
    this.setState({
      weekendsVisible: !this.state.weekendsVisible,
    });
  };

  handleEventClick = (clickInfo) => {
    console.log(this.state.isClicked);
    this.setState({
      showDialogue: !this.state.showDialogue,
    });
  };

  handleEvents = (events) => {
    this.setState({
      currentEvents: events,
    });
  };

  renderEventContent(eventInfo) {
    console.log(eventInfo);
    return (
      <>
        <AppointmentDetailsCalander
          id={eventInfo.event.id}
          timeText={eventInfo.timeText}
          title={eventInfo.event.title}
        ></AppointmentDetailsCalander>
      </>
    );
  }

  renderSidebarEvent(event) {
    return (
      <li key={event.id}>
        <b>
          {formatDate(event.start, {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </b>
        <i>{event.title}</i>
      </li>
    );
  }

  render() {
    let initialValue = [];
    this.props.appointmentList.map((appointment) => {
      if (appointment.status && appointment.status.indexOf("CANCEL") < 0) {
        initialValue.push({
          id: appointment.id,
          title: (
            (appointment.doctorDetails && appointment.doctorDetails.lastName
              ? appointment.doctorDetails.lastName
              : "") +
            " ; " +
            (appointment.patientDetails && appointment.patientDetails.firstName
              ? appointment.patientDetails.firstName
              : "") +
            (appointment.patientDetails && appointment.patientDetails.lastName
              ? appointment.patientDetails.lastName
              : "")
          ).toUpperCase(),
          start: appointment.startDateTime,
          end: appointment.endDateTime,
        });
      }
    });
    return (
      <div className="demo-app">
        <div className="demo-app-main">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            themeSystem="Materia"
            initialView="timeGridDay"
            //editable={true}
            //selectable={true}
            //selectMirror={true}
            dayMaxEvents={true}
            weekends={this.state.weekendsVisible}
            initialEvents={initialValue} // alternatively, use the `events` setting to fetch from a feed
            select={this.handleDateSelect}
            eventContent={this.renderEventContent} // custom render function
            eventClick={this.handleEventClick}
            //eventsSet={this.handleEvents} // called after events are initialized/added/changed/removed
            /* you can update a remote database when these fire:
            eventAdd={function(){}}
            eventChange={function(){}}
            eventRemove={function(){}}
            */
          />
        </div>
      </div>
    );
  }
}
